import { createStore } from 'vuex'

export default createStore({
  state: {
    numStars: 100,
    numBrightStars: 10
  },
  mutations: {
    setNumStars(state, value) {
      state.numStars = value
    },
    setNumBrightStars(state, value) {
      state.numBrightStars = value
    }
  },
  actions: {
    updateNumStars({ commit }, value) {
      commit('setNumStars', value)
    },
    updateNumBrightStars({ commit }, value) {
      commit('setNumBrightStars', value)
    }
  },
  modules: {
  }
})
